import React from "react";
import { cn } from "./cn";

export function Card({ className, children, ...rest }) {
  return (
    <article
      className={cn(
        "rounded-3xl border border-arena/10 bg-white/95 shadow-card backdrop-blur-sm",
        className
      )}
      {...rest}
    >
      {children}
    </article>
  );
}

export function CardHeader({ className, children, ...rest }) {
  return (
    <header className={cn("px-5 pt-5 pb-2", className)} {...rest}>
      {children}
    </header>
  );
}

export function CardBody({ className, children, ...rest }) {
  return (
    <div className={cn("px-5 py-3", className)} {...rest}>
      {children}
    </div>
  );
}

export function CardFooter({ className, children, ...rest }) {
  return (
    <footer className={cn("px-5 pb-5 pt-2", className)} {...rest}>
      {children}
    </footer>
  );
}

export default Card;
